import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { CallNumberPlugin } from './native-plugins/call-number.plugin';
import { EmailComposerPlugin } from './native-plugins/email-composer.plugin';

import { Observable } from 'rxjs';

import { Contact } from '../models/contact.model';

import { OverlayService } from './overlay.service';
import { SettingsService } from './settings.service';

import { AppConfig, TOKEN_CONFIG } from '../config/app.config';

@Injectable({ providedIn: 'root' })
export class ContactService {
  constructor(
    private http: HttpClient,
    private inAppBrowser: InAppBrowser,
    private callNumberPlugin: CallNumberPlugin,
    private emailComposerPlugin: EmailComposerPlugin,
    private overlayService: OverlayService,
    private settingsService: SettingsService,
    private translateService: TranslateService,
    @Inject(TOKEN_CONFIG) private config: AppConfig,
  ) {}

  public submit(data: Contact): Observable<void> {
    const url = this.config.routes.postContact.url;

    // Horrible workaround for non json responses
    // GITHUB ISSUE: https://github.com/angular/angular/issues/18586
    return this.http.post<void>(url, data, { responseType: 'text' as 'json' });
  }

  public callBilbayt(): Promise<void> {
    return this.callNumberPlugin.call(this.settingsService.getCountry().contactPhoneNumber);
  }

  public callVendor(vendorPhoneNumber: string): Promise<void> {
    return this.callNumberPlugin.call(vendorPhoneNumber);
  }

  public emailBilbayt(): Promise<void> {
    return this.emailComposerPlugin
      .open({
        to: this.config.contactEmail,
        subject: this.translateService.instant('CONTACT_EMAIL_SUBJECT') as string,
      })
      .then((couldOpen) => {
        if (!couldOpen) {
          this.overlayService.showToast({
            message: this.translateService.instant('ERROR_MESSAGE.DEFAULT_MESSAGE') as string,
            showCloseButton: true,
            type: 'error',
          });
        }
      });
  }

  public startChatWithBilbayt(): void {
    this.inAppBrowser.create(this.settingsService.getWhatsAppChatLink(), '_system');
  }

  public startChatWithBilbaytUsingPhoneNumber(phoneNumber: string, text?: string): void {
    this.inAppBrowser.create(`whatsapp://send?phone=${phoneNumber}${text ? `&text=${text}` : ''}`, '_system');
  }
}
